<div class="cell-footer">
    <div class="main-label">Current Settings</div>
    <div class="values">
        <div class="value-item">
            <div class="value-label">Value</div>
            <div class="setting-value">Value</div>
        </div>
        <div class="value-item">
            <div class="value-label">Value</div>
            <div class="setting-value">Value</div>
        </div>
    </div>
</div>
